import React, { useState, useEffect } from 'react';

function App() {
  const [news, setNews] = useState([]);
  const [category, setCategory] = useState('health');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`http://shop-euro.com/api/api.php?domeniu=${category}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Invalid server response: ' + response.status);
        }
        return response.json();
      })
      .then(data => {
        if (data.articles) {
          setNews(data.articles);
          setError(null);
        } else {
          setError('No articles found in the API response');
        }
      })
      .catch(error => {
        setError('Error fetching news: ' + error.message);
        setNews([]);
      });
  }, [category]);

  return (
    <div className="news-container">
      <header className="news-header">
        <img src="/logo.png" alt="Global Headlines News Logo" className="logo" />
        <h1>Global Headlines News</h1>
        <div className="category-selector">
          <label htmlFor="category">Select Category: </label>
          <select
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="health">Health</option>
            <option value="science">Science</option>
            <option value="sports">Sports</option>
            <option value="business">Business</option>
            <option value="entertainment">Entertainment</option>
            <option value="technology">Technology</option>
            <option value="general">General (Politics & More)</option>
          </select>
        </div>
      </header>
      <main>
        {error && <p className="error-message">{error}</p>}
        {news.length > 0 ? (
          <div className="news-grid">
            {news.map((article, index) => (
              <div key={index} className="news-card">
                {article.urlToImage && (
                  <img src={article.urlToImage} alt={article.title} className="news-image" />
                )}
                <h2>
                  <a href={article.url} target="_blank" rel="noopener noreferrer">
                    {article.title}
                  </a>
                </h2>
                <p>{article.description}</p>
                <span className="news-source">Source: {article.source.name}</span>
              </div>
            ))}
          </div>
        ) : (
          <p>No news available for this category.</p>
        )}
      </main>
    </div>
  );
}

export default App;